import { createUrl, restDelete, restGet, restPatch, restPost } from '~/src/dash/api/rest';

export interface IDemandSourceRateLimit {
  ID: number;
  PublisherID: number;
  DemandSourceName: string;
  RateLimit: number;
}

export async function getAllDemandSourceRateLimitsForPublisher(
  publisherID: string,
): Promise<[IDemandSourceRateLimit[] | undefined, string | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/demand_source_rate_limit', publisherID);

  try {
    return [(await restGet<IDemandSourceRateLimit[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function createDemandSourceRateLimit(
  demandSourceRateLimit: IDemandSourceRateLimit,
  publisherID: string,
): Promise<[IDemandSourceRateLimit | undefined, string | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/demand_source_rate_limit', publisherID);

  try {
    return [
      (await restPost<IDemandSourceRateLimit>(reqUrl, demandSourceRateLimit)).parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

export async function updateDemandSourceRateLimit(
  demandSourceRateLimit: IDemandSourceRateLimit,
  id: string,
  publisherID: string,
): Promise<[IDemandSourceRateLimit | undefined, string | undefined]> {
  const reqUrl = createUrl(
    '/publishers/' + publisherID + '/demand_source_rate_limit/' + id,
    publisherID,
  );

  try {
    return [
      (await restPatch<IDemandSourceRateLimit>(reqUrl, demandSourceRateLimit)).parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

export async function deleteDemandSourceRateLimit(
  id: string,
  publisherID: string,
): Promise<[null | undefined, string | undefined]> {
  const reqUrl = createUrl(
    '/publishers/' + publisherID + '/demand_source_rate_limit/' + id,
    publisherID,
  );

  try {
    return [(await restDelete<null>(reqUrl, null)).parsedBody, undefined];
  } catch (e) {
    return [null, e];
  }
}
